import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import generatePassword from 'password-generator';

export default class Filters extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.filters = $('.is-filter-form');
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {

    $(document).on('click', '.is-filters-switcher', (event) => {
      return this.onSwitcherClick(event);
    });

    $(document).on('submit', '.is-filter-form', (event) => {
      return this.onSubmit(event);
    });

  }

  onSwitcherClick(event) {

    let button = $(event.currentTarget),
        buttonText = button.find('span:eq(1)');

    event.preventDefault();

    if (this.filters.hasClass('is-hidden-form')) {
      buttonText.text(
        this.App.Language.get('filters.hide')
      );
      return this.toggleState('show');
    }

    buttonText.text(
      this.App.Language.get('filters.show')
    );
    return this.toggleState('hide');

  }

  toggleState(state) {
    if (state === 'show') {
      return this.filters.removeClass('is-hidden-form');
    }
    return this.filters.addClass('is-hidden-form');
  }

  onSubmit(event) {
    let form = $(event.currentTarget),
        inputs = form.find(":input").filter(function(){ return !this.value; });

    inputs.filter(function(){
      return !this.value;
    }).prop('disabled', true);

    setTimeout(() => {
      inputs.filter(function(){
        return !this.value;
      }).prop('disabled', false);
    }, 5);

    return true;
  }

}